import { inject } from '@angular/core';
import { ResolveFn } from '@angular/router';
import { LoadingService } from '@mds/ngx-core';
import { finalize, first } from 'rxjs';
import { DeploymentsClient, ShiftResponse } from '..';

export const assignableShiftsResolver: ResolveFn<ShiftResponse[]> = () => {
  const client = inject(DeploymentsClient);
  const loadingService = inject(LoadingService);

  loadingService.start();

  return client.getAssignableShifts().pipe(
    first(),
    finalize(() => loadingService.end()),
  );
};
